/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import { useFormik } from 'formik'
import * as Yup from "yup";
import { useToast } from '../../../components/Toats';
import { StepperComponent } from '../../../../../_metronic/assets/ts/components';
import { postProposalsOne, putProposalOne } from '../../../../services/proposalsService';
import { KTSVG } from '../../../../../_metronic/helpers';
import { StepModal } from './components/stepModal';
import { LoadingSpan } from '../../../components/Loadings/loadingSpan';
import { formatDateToInput } from '../../../../utils/date';

type DataForm = {
  description: string | null,
  title: string | null,
  address: string | null,
  dateInit: string | Date | null,
  dateEnd: string | Date | null,
  idClient: string | null,
  idUnitBranch: string | null,
  idPlant: string | null,
  idsCollaborator: string[] | [],
  idPhaseFunnel: string | null,
}

type Props = {
    id?: string;
    data?: DataForm;
    prevStep: any;
    submitStep: any;
    isSubmitButton: any;
    setData: any

    handleClose: () => void
    clientsReloadToken?: number
    newClientIdToSelect?: string
    onAppliedNewClientSelection?: () => void
    onOpenNewClientModal?: () => void
}

const validationSchema = Yup.object().shape({
  description: Yup.string(),
  title: Yup.string(),
  address: Yup.string(),
  dateInit: Yup.date(),
  dateEnd: Yup.date(),
  idClient: Yup.string(),
  idUnitBranch: Yup.string(),
  idPlant: Yup.string(),
  idsCollaborator: Yup.array()
  .of(Yup.string())
  .notRequired()
  .default([]),
  idPhaseFunnel: Yup.string(),
});

const modalsRoot = document.getElementById('root-modals') || document.body

const ScreenAddEditProposal = ({
  handleClose,
  data,
  id,
  prevStep,
  submitStep,
  isSubmitButton,
  setData,
  clientsReloadToken = 0,
  newClientIdToSelect,
  onAppliedNewClientSelection,
  onOpenNewClientModal,
}: Props) => {
  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)

  const [initialValues, setInitialValues] = useState<DataForm>({
    description: null,
    title: null,
    address: null,
    dateInit: null,
    dateEnd: null,
    idClient: null,
    idUnitBranch: null,
    idPlant: null,
    idsCollaborator: [],
    idPhaseFunnel: null,
  })
  const [hasError, setHasError] = useState(false)
  const [myError, MyError] = useState(false)
  const [loading, setLoading] = useState(false)
  
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const updateData = (fieldsToUpdate: any) => {
    const updatedData = {...initialValues, ...fieldsToUpdate}
    setInitialValues(updatedData)
  }

  const closed = () => {
    //formik.setValues(initialValues)
    submitStep()
    //handleClose()
  }

  const postProposalSubmit = async () => {
    try {
      setLoading(true)
      const myData = {
        description: formik.values.description,
        title: formik.values.title,
        address: formik.values.address,
        dateInit: formik.values.dateInit,
        dateEnd: formik.values.dateEnd,
        idClient: formik.values.idClient,
        idUnitBranch: formik.values.idUnitBranch,
        idPlant: formik.values.idPlant,
        idsCollaborator: formik.values.idsCollaborator,
        idPhaseFunnel: formik.values.idPhaseFunnel,
      }
      Object.keys(myData).forEach((prop) => {
        if (myData[prop] === null) {
          delete myData[prop];
        }
      });

      const myProposalResult = await postProposalsOne(myData);

      if(myProposalResult){
        myProposalResult.idPhaseFunnel = myProposalResult.phaseFunnel ? myProposalResult.phaseFunnel.id : null; 
        myProposalResult.idsCollaborators = myProposalResult.collaborators && myProposalResult.collaborators.length > 0 ? myProposalResult.collaborators.map((collaborator: any) => collaborator.id) : []
        myProposalResult.idPlant = myProposalResult.plant ? myProposalResult.plant.id : null;
        myProposalResult.idClient = myProposalResult.client ? myProposalResult.client.id : null;
        myProposalResult.idUnitBranch = myProposalResult.unitBranch ? myProposalResult.unitBranch.id : null;
        myProposalResult.idsCollaborator = myProposalResult.collaborators && myProposalResult.collaborators.length > 0 ? [myProposalResult.collaborators[0].id] : null;
      }

      toggleToast("Sucesso ao cadastrar a proposta. ", "success");
      setData(myProposalResult);

    } catch (error) {
      console.log('erro',error)
      toggleToast("Erro ao cadastrar a proposta. ", "error")
    }finally{
      setLoading(false)
      closed()
    }
  }


  const updateOSSubmit = async (id: string) => {
    try {
      setLoading(true)
      const myData = {
        description: formik.values.description,
        title: formik.values.title,
        address: formik.values.address,
        dateInit: formik.values.dateInit,
        dateEnd: formik.values.dateEnd,
        idClient: formik.values.idClient,
        idUnitBranch: formik.values.idUnitBranch,
        idPlant: formik.values.idPlant,
        idsCollaborator: formik.values.idsCollaborator,
        idPhaseFunnel: formik.values.idPhaseFunnel,
      }
      Object.keys(myData).forEach((prop) => {
        if (myData[prop] === null) {
          delete myData[prop];
        }
      });
      const myProposalResult = await putProposalOne(id, myData)
      //toggleToast("Sucesso ao atualizar a proposta. ", "success")

      if(myProposalResult){
        myProposalResult.idPhaseFunnel = myProposalResult.phaseFunnel ? myProposalResult.phaseFunnel.id : null; 
        myProposalResult.idsCollaborators = myProposalResult.collaborators && myProposalResult.collaborators.length > 0 ? myProposalResult.collaborators.map((collaborator: any) => collaborator.id) : []
        myProposalResult.idPlant = myProposalResult.plant ? myProposalResult.plant.id : null;
        myProposalResult.idClient = myProposalResult.client ? myProposalResult.client.id : null;
        myProposalResult.idUnitBranch = myProposalResult.unitBranch ? myProposalResult.unitBranch.id : null;
        myProposalResult.idsCollaborator = myProposalResult.collaborators && myProposalResult.collaborators.length > 0 ? [myProposalResult.collaborators[0].id] : null;
      }

      setData(myProposalResult);

    } catch (error) {
      console.log('erro',error)
      //toggleToast("Erro ao atualizar a proposta. ", "error")
    }finally{
      setLoading(false)
      //submitStep()
      closed()
    }
  }


  const submit = () => {
    if(id){
      updateOSSubmit(id)
    }else{
        postProposalSubmit()
    }
  }

  const checkInputs = (): boolean => {
    if (!formik.values.idUnitBranch 
        || !formik.values.title 
        || !formik.values.idPhaseFunnel
        ) {
      return false
    }
    return true
  }

  const nextStep = () => {
    setHasError(false)

    if (!checkInputs()) {
    setHasError(true)
    return
    }
    submit()
    
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: nextStep,
  });


  useEffect(() => {
    if(data){
      const myObject = {
        description: data && data.description ? data.description : null,
        title: data &&  data.title ? data.title : null,
        address: data &&  data.address ? data.address : null,
        dateInit: data &&  data.dateInit ? formatDateToInput(data.dateInit) : null,
        dateEnd: data &&  data.dateEnd ? formatDateToInput(data.dateEnd) : null,
        idClient: data &&  data.idClient ? data.idClient : null,
        idUnitBranch: data && data.idUnitBranch ? data.idUnitBranch : null,
        idPlant: data &&  data.idPlant ? data.idPlant : null,
        idsCollaborator: data && data.idsCollaborator ? data.idsCollaborator : [],
        idPhaseFunnel: data.idPhaseFunnel ? data.idPhaseFunnel : null,

      }
      formik.setValues(myObject)
    }else{
      formik.setValues(initialValues)
    }
  }, [data])


  return (
    <div className='modal-body py-lg-10 px-lg-10 bg-light' style={{marginLeft: '5%', marginRight: '5%'}}>
      <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
        
        <div className='flex-row-fluid py-lg-1 px-lg-2'>
            <form noValidate id='kt_modal_create_app_form' >
            <StepModal
              data={initialValues}
              updateData={updateData}
              hasError={hasError}
              formik={formik}
              clientsReloadToken={clientsReloadToken}
              newClientIdToSelect={newClientIdToSelect}
              onAppliedNewClientSelection={onAppliedNewClientSelection}
              onOpenNewClientModal={onOpenNewClientModal}
            />

            <div className='d-flex flex-stack pt-10' style={{justifyContent: 'end'}}>
                <div style={{display: 'flex', gap: '1rem'}}>
                  {/* <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      disabled={loading}
                      //data-kt-stepper-action='submit'
                      onClick={nextStep}
                  >
                      {id ? "Editar Proposta" : "Gerar Proposta" }{' '}
                      {
                      loading ? 
                          <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                      :
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr064.svg'
                          className='svg-icon-3 ms-2 me-0'
                        />
                      }
                  </button> */}


            <div className='d-flex flex-stack pt-15'>
                <div className='mr-2'>
                <button
                    onClick={prevStep}
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                >
                    <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-4 me-1'
                    />
                    Voltar
                </button>
                </div>

                <div>
                <button 
                  onClick={nextStep} 
                  className='btn btn-lg btn-primary me-3'
                  disabled={loading}
                  type='button'
                >
                    <span className='indicator-label'>
                      {!data && 'Cadastrar Proposta'}
                      {data && !isSubmitButton && 'Proximo Passo'}
                      {data && isSubmitButton && 'Salvar'}
                    
                      {loading ? 
                        <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                      :
                        <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-3 ms-2 me-0'
                        />
                      }
                    </span>
                </button>
                </div>
            </div>
                </div>
            </div>
            </form>
        </div>
      </div>
    </div>
    
  )
}

export {ScreenAddEditProposal}
